<div class="screen">
  <div class="screen-inner">
    <app-shell nav="back" title="Players" [backTo]="backTo"></app-shell>

    @if (dashboard) {
      <p class="section-label">Tap a name to mark cash collected</p>

      @if (dashboard.registrations.length === 0) {
        <p class="page-note">Nobody has signed up yet.</p>
      } @else {
        <div class="card">
          @for (player of dashboard.registrations; track player.userId) {
            <button class="row" type="button" [disabled]="busy" (click)="togglePaid(player)">
              <span class="row-body">
                <span class="row-title">{{ player.displayName }}</span>
                <span class="row-meta">{{ player.handicapIndex }} index{{ extras(player) ? ' · ' + extras(player) : '' }}</span>
              </span>
              @if (player.paid) {
                <span class="pill">Paid</span>
              } @else {
                <span class="pill pill-muted">Owes</span>
              }
            </button>
          }
        </div>
      }

      <button class="btn-primary" type="button" (click)="add()">Add players</button>
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
